import styled from 'styled-components';

export const BlockNonceContainer = styled.div`
	background-color: #fafafa;
	/* height: 50px; */
	padding: 2px 7px;
	width: min-content;
	height: min-content;
	font-size: 13px;
	font-weight: 300;
	border: 1px solid #d9d9d9;
	border-radius: 4px;
	letter-spacing: -0.3px;
`;
